<template>
  <I18nLinkWithFallback
    :name="childPageName"
    :localizedData="localizedData"
    :class="$style.root"
    :style="{
      '--left': `${item?.attributes?.percentage_left || 0}%`,
      '--top': `${item?.attributes?.percentage_top || 0}%`,
      '--index': index + 2
    }"
  >
    <span>
      {{ index + 1 }}
    </span>
  </I18nLinkWithFallback>

</template>

<script setup>
const props = defineProps({
  item: Object,
  index: Number,
  childPageName: String
})

const localizedData = i18nGetLocalizedData(baseStrapiGetAttributes(props?.item))
</script>

<style module>
.root {
  composes: font-size-small from global;
  line-height: 0;

  width: max(min(3rem, 2.5vw), 2rem);
  aspect-ratio: 1;
  border-radius: 50%;

  position: absolute;
  top: var(--top);
  left: var(--left);
  transform: translate(-50%, -50%) scale(.65);

  transition: transform 0.3s ease-in-out;
  transform-origin: center;

  background-color: var(--color--primary);
  color: var(--color--white);

  display: flex;
  align-items: center;
  justify-content: center;
}

.root:global(.router-link-exact-active),
.root:hover,
.root[data-active] {
  background-color: var(--color--accent);
  transform: translate(-50%, -50%) scale(1);
  z-index: 10;
}

.root span {
  transform: translateY(-.075em);
}
</style>
